export default __webpack_public_path__ + "997df1609792a3e37d426d25532588ff.jpg";